<form [formGroup]="filterForm">
  <div class="manage-filtersdialog">
    <div class="title">
      <h3 class="title-text" l10nTranslate>shared.filters</h3>
    </div>
    <section class="section">
      <div class="section-header" l10nTranslate>shared.status</div>
      <div class="section-labels">
        <mat-checkbox
          class="chkbox-control"
          [checked]="statusIdsSelected[option.key]"
          (change)="onStatusChange($event)"
          [value]="option.key"
          *ngFor="let option of statusOptions"
          formArrayName="statusId"
          >{{ option.value }}</mat-checkbox
        >
      </div>
    </section>
    <div class="seperator"></div>
    <section class="section">
      <div class="section-header" l10nTranslate>shared.daysOpen</div>
      <div class="section-labels">
        <mat-radio-group formControlName="date">
          <mat-radio-button
            [checked]="
              (selectedFilters?.date?.lte && option.key.lte === selectedFilters?.date?.lte) ||
              (selectedFilters?.date?.gte && option.key.gte === selectedFilters?.date?.gte)
            "
            [value]="option.key"
            *ngFor="let option of daysOpenOptions"
            >{{ option.value | xTranslate }}</mat-radio-button
          >
        </mat-radio-group>
      </div>
    </section>
    <div class="seperator"></div>
    <section class="section">
      <div class="section-header" l10nTranslate>shared.withAttachments</div>
      <div class="section-labels">
        <mat-radio-group formControlName="hasAttachments">
          <mat-radio-button [value]="option.key" *ngFor="let option of attachmentOptions">
            {{ option.value | xTranslate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </section>
    <div class="seperator"></div>
    <section class="section">
      <div class="section-header" l10nTranslate>shared.createdBy</div>
      <div class="section-labels">
        <p-multiSelect [options]="createdBySelectItems" formControlName="createdBy"></p-multiSelect>
      </div>
    </section>
    <div class="seperator"></div>
    <section class="section">
      <div class="section-header" l10nTranslate>shared.assignedTo</div>
      <div class="section-labels">
        <p-multiSelect [options]="assignToSelectItems" formControlName="assignedTo"></p-multiSelect>
      </div>
    </section>
  </div>
  <div class="actions">
    <button mat-button color="primary" (click)="reset()" l10nTranslate>shared.reset</button>
    <button
      type="submit"
      value="submit"
      mat-flat-button
      color="primary"
      (click)="apply(filterForm.value)"
      l10nTranslate
    >
      shared.apply
    </button>
  </div>
</form>
